module.exports = __webpack_public_path__ + "media/images/spellcheck2-a91ffd7c4bbd9d1a20c017e946454387.png";